import { render, staticRenderFns } from "./TopSonIncidencesTableDetail.vue?vue&type=template&id=afdb5a62&scoped=true"
import script from "./TopSonIncidencesTableDetail.vue?vue&type=script&lang=js"
export * from "./TopSonIncidencesTableDetail.vue?vue&type=script&lang=js"
import style0 from "./TopSonIncidencesTableDetail.vue?vue&type=style&index=0&id=afdb5a62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afdb5a62",
  null
  
)

export default component.exports